/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';

import Discuss from 'parts/Discuss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Fade } from "react-awesome-reveal";
import Button from 'elements/Button';

// Replace with real image when available

export default function LocalGovernmentsAndMunicipalities() {
  return (
    <>

      {/* CHALLENGES */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold text-center mb-6">Challenges in Public Sector IT</h2>
          <p className="text-center text-gray-600 mb-10">
            Municipal organizations must support communities with dependable, secure, and efficient systems.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Cybersecurity Threats</h3>
              <p className="text-gray-600">Government networks are top targets. Protection requires monitoring, encryption, and rapid response.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Public Service Delivery</h3>
              <p className="text-gray-600">Reliable systems ensure citizens can access essential services without disruption.</p>
            </div>

            <div className="p-6 bg-white rounded-2xl shadow-md">
              <h3 className="text-xl font-semibold text-theme-blue mb-2">Aging Infrastructure</h3>
              <p className="text-gray-600">Legacy systems limit efficiency; modern replacements improve performance and reduce costs.</p>
            </div>

          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-16">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          <div>
            <h2 className="text-3xl lg:text-4xl text-theme-blue font-extrabold mb-4">How We Support Municipalities</h2>
            <ul className="space-y-6 text-gray-600">

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Enhanced Network Security</p>
                  <p className="text-sm">Firewalls, MFA, encrypted data, and threat detection safeguard public systems.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Improved Operational Efficiency</p>
                  <p className="text-sm">Modern cloud tools, automation, and collaboration platforms reduce administrative workload.</p>
                </div>
              </li>

              <li className="flex items-start gap-4">
<Fade triggerOnce delay={20}>
                  <span className="text-2xl leading-none"> <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#47d14a" }} /> </span></Fade>
                <div>
                  <p className="font-semibold">Reliable Citizen Services</p>
                  <p className="text-sm">Upgraded infrastructure ensures essential services stay online and accessible.</p>
                </div>
              </li>

            </ul>

            <div className="mt-6">
              <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Request a Government IT Assessment</Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-6">
            <h3 className="text-xl font-semibold text-theme-blue mb-4">Typical Outcomes</h3>
            <div className="space-y-4 text-gray-600">
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Stronger cybersecurity posture</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>More reliable public services</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Lower operating costs</strong></p>
              <p> <FontAwesomeIcon icon={faCircleCheck}  size="lg" style={{ color: "#47d14a" }} /> <strong>Better citizen satisfaction</strong></p>
            </div>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-light-theme-purple to-white">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-theme-blue font-bold">Ready to modernize your municipality&rsquo;s IT?</h2>
            <p className="text-gray-600 mt-2">We provide secure, efficient, and future-ready technology solutions for public organizations.</p>
          </div>

          <div>
            <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full hover:bg-dark-theme-purple transition duration-200">Start Now</Button>
          </div>
        </div>
      </section>

      <Discuss />
    </>
  );
}
